<template>
  <div class="container">
    <h1 class="has-text-centered">{{ texts[langPrefix].pageTitle }}</h1>
    <div
      class="padding subtitle is-5 has-text-centered"
      v-html="texts[langPrefix].description"
    ></div>
    <div
      v-if="cookieApiData.length > 0"
      class="form padding has-background-grey-light"
    >
      <div class="columns padding">
        <div class="column">
          <div class="content">
            <h4 v-html="texts[langPrefix].cookieOptionTitle"></h4>
            <p v-for="(cookieOption, index) in cookieApiData" :key="index">
              <label
                class="customCheckbox"
                :class="{ 'is-disabled': !cookieOption.IsEditable }"
              >
                <input
                  type="checkbox"
                  :disabled="!cookieOption.IsEditable"
                  :checked="myCurrentCookieSettings[cookieOption.Key] === 1"
                  @change="onChange(cookieOption, $event)"
                />
                <span
                  class="checkmark"
                  :class="{
                    'is-disabled has-background-grey': !cookieOption.IsEditable,
                  }"
                >
                  <i class="has-text-white font-icon s2m-icon-check-mark"></i>
                </span>
                <span
                  class="shortDescription"
                  v-html="cookieOption.Short"
                ></span>
              </label>
            </p>
            <hr class="separator" />
            <button
              class="button is-medium is-success"
              @click="saveCookieSettings"
            >
              Save & return
            </button>
          </div>
        </div>
        <div
          class="
            has-text-primary
            content
            column
            has-text-centered has-background-cyan
            is-full-mobile is-one-third-tablet is-one-third-desktop
          "
        >
          <h4 class="has-text-primary title is-4">
            For which websites do I give permission
          </h4>
          <div class="is-size-5 has-text-weight-bold">
            {{ texts[langPrefix].consetTo }}
          </div>
        </div>
      </div>
    </div>
    <hr class="separator" />
    <div class="content padding columns is-multiline">
      <div
        class="descriptionsWrapper column is-4"
        v-for="cookie in cookieApiData"
        :key="cookie.Id"
      >
        <div class="cookieDescription">
          <h3 class="">{{ cookie.Name }}</h3>
          <div class="content" v-html="cookie.Description"></div>
        </div>
      </div>
      <div class="descriptionsWrapper column is-4">
        <div class="cookieDescription">
          <h3 class="">
            {{ texts[langPrefix].changeCookieTitle }}
          </h3>
          <div
            class="content"
            v-html="texts[langPrefix].changeCookieText"
          ></div>
        </div>
      </div>
    </div>
    <hr class="separator" />
  </div>
</template>

<script>
import cookie from "@/providers/cookie.js";
import { eraseCookie, getCookie, setCookie } from "@/utils/browserStorage";
export default {
  data() {
    return {
      cName: "s2m_cc",
      myCurrentCookieSettings: {},
      cookieApiData: {},
      langPrefix: "en",
      websites: [
        "locals.seats2meet.com",
        "magazine.seats2meet.com",
        "now.seats2meet.com",
        "passport.seats2meet.com",
        "seats4silence.seats2meet.com",
        "shop.seats2meet.com",
        "www.seats2meet.com",
      ],
      texts: {
        en: {
          pageTitle: "Cookie settings",
          description:
            "<p>Seats2meet uses functional and analytical cookies which are needed for the platform to function optimally. &nbsp;Below an explanation of the specific types of cookies you may want to accept.</p><p>Beware: updated cookie settings are only saved in the web browser you are using at that moment.</p>",
          cookieOptionTitle: "We use the following cookies:",
          footerContact: "Contact S2M International",
          privacyPolicy: "Privacy Policy",
          terms: "Terms",
          changeCookieTitle: "How to change your cookie settings",
          changeCookieText:
            'At any time you can change your cookie settings on Seats2meet. &nbsp;<br />Use the cookie settings link to reach the <a href="https://www.seats2meet.com/terms">terms and conditions</a> page as well as your passport page for your cookie settings.',
          consetTo:
            "You consent to the domain and all subdomains of Seats2meet.com.",
        },
        nl: {
          pageTitle: "Cookie-instellingen",
          description:
            "<p>Seats2Meet.com maakt gebruik van functionele en analytische cookies die noodzakelijk zijn om ons platform zo goed mogelijk te laten functioneren. Hieronder kan je aangeven welke andere soorten cookies je wilt accepteren.</p><p>Let op: aangepaste instellingen worden alleen opgeslagen binnen de browser waar je op dit moment de instellingen mee bewerkt.</p>",
          cookieOptionTitle: "Wij gebruiken de volgende cookies:",
          footerContact: "Contact S2M International",
          privacyPolicy: "Privacy Policy",
          terms: "Terms",
          changeCookieTitle: "Cookie instellingen aanpassen?",
          changeCookieText:
            'De cookie instellingen op Seats2Meet.com zijn te allen tijde te wijzigen naar je persoonlijke voorkeur. De pagina waarop je deze instellingen kunt wijzigen is te bereiken via de Cookie-instellingen link, de <a href="https://www.seats2meet.com/terms">Terms &amp; Conditions</a> pagina en jouw persoonlijke paspoort.',
          consetTo:
            "Je geeft toestemming voor het domein en alle subdomeinen van Seats2meet.com.",
        },
      },
    };
  },

  created() {
    this.getLatest();
  },
  methods: {
    checkReferer() {
      let referer = document.referrer;

      if (referer === "" && this.websites.indexOf(referer) === -1) {
        referer = process.env.VUE_APP_S2M_BASE_URL;
      }
      return referer;
    },

    getLatest() {
      var self = this;
      cookie.methods.getLatest().then((response) => {
        let data = response.data;
        let cookieValue = getCookie(self.cName);
        let isNewCookie = false;
        if (cookieValue !== "") {
          this.myCurrentCookieSettings = JSON.parse(cookieValue);

          if (this.myCurrentCookieSettings.Version !== data.Version) {
            isNewCookie = true;
            // Delete cookie when versions are not the same
            eraseCookie("s2m_cc");
          } else {
          }
        } else {
          isNewCookie = true;
        }

        if (isNewCookie) {
          self.myCurrentCookieSettings = {};
          self.myCurrentCookieSettings.Version = data.Version;
          self.myCurrentCookieSettings.Id = data.Id;
          for (let i in data.CookieTypes) {
            // Add value to my cookie settings
            self.myCurrentCookieSettings[data.CookieTypes[i].Key] = data
              .CookieTypes[i].IsEditable
              ? -1
              : 1;
            if (data.CookieTypes[i].Key === "ca") {
              self.myCurrentCookieSettings[data.CookieTypes[i].Key] = 1;
            }
          }
        }

        this.cookieApiData = data.CookieTypes;
      });
    },

    getOptionText(key) {
      return key;
    },

    onChange(option, evt) {
      let self = this;
      self.myCurrentCookieSettings[option.Key] = evt.target.checked ? 1 : -1;
    },

    checkIfEditable(val) {
      return !val.IsEditable;
    },

    saveCookieSettings() {
      console.info(this.myCurrentCookieSettings);
      setCookie(
        this.cName,
        JSON.stringify(this.myCurrentCookieSettings),
        300,
        true
      );
      let t = setTimeout(() => {
        window.location.href = this.checkReferer();
      }, 250);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/template.scss";

.customCheckbox {
  display: block;
  padding-left: 40px;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-align: left;

  &:hover input ~ .checkmark {
    background-color: #ccc;
  }

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    left: 0;
    top: 22%;

    &:checked ~ .checkmark {
      border-color: $green;
      background-color: $green;

      i {
        display: inline-block;
      }
    }
  }

  .checkmark {
    box-sizing: border-box;
    position: absolute;
    top: 3px;
    left: 1px;
    height: 25px;
    width: 25px;
    border: 2px solid #bebebe;
    background-color: white;
    text-align: center;
    i {
      display: none;
    }
  }

  .text {
    text-align: left;
  }
}
.shortDescription {
}

.cookieDescription {
  h3 {
    min-height: auto;
  }
  @media screen and (min-width: 769px) {
    h3 {
      min-height: 50px;
    }
  }
  a {
    color: $blue;
  }
}
</style>
